import React, { useState } from "react";
import { useStyles } from "./TooltipStyles";
import { TooltipProps } from "./types";

const Tooltip = ({ title, s, children }: TooltipProps) => {
  const [tooltipElId] = useState(
    `tooltip-${Math.random().toString(36).substring(2)}`,
  );

  const styles = useStyles();

  // Clicking the tooltip itself and its children should not treat as a click on
  // its parent. For example, if the tooltip is on a button, clicking a
  // hyperlink inside the tooltip should not trigger the button's click handler.
  const stopPropagation = (
    event:
      | React.MouseEvent<HTMLSpanElement>
      | React.KeyboardEvent<HTMLSpanElement>,
  ) => {
    event.stopPropagation();
  };

  return (
    <div className={styles.tooltipContainer} aria-describedby={tooltipElId}>
      {children}
      <span
        className={styles.tooltipText}
        style={s}
        id={tooltipElId}
        onClick={stopPropagation}
        onKeyDown={stopPropagation}
        role="button"
        tabIndex={0}>
        {title}
      </span>
    </div>
  );
};

export default Tooltip;
